import { combineReducers } from 'redux';
import auth from "./auth";
import shop from "./shop";
import products from "./products";
import cart from "./cart";
import months from "./months";
import ux from "./ux";

const subsApp = combineReducers({
  auth, products, cart, months, shop, ux
})

export default subsApp;



// WEBPACK FOOTER //
// ./src/reducers/index.js